import httpbaseURL from "../common/axios";
class SupplierPaymentDetailService {
  CreateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPaymentDetail/Create", doc);
  }
  UpdateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPaymentDetail/Update", doc);
  }
  GetList() {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/List");
  }
  GetData(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/Get?Id=" + doc);
  }
  DeleteData(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/SupplierPaymentDetail/Delete?Id=" + doc
    );
  }
  GetPaymentMethodList() {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/PaymentMethodList");
  }
  GetBySupplierId(Id, HId, BId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/GetBySupplierId?SupplierId=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId);
  }
  CreateSubDetailsData(doc) {
    debugger
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPaymentSubDetails/Create", doc);
  }
}
export default new SupplierPaymentDetailService();
